import React from "react";
import { Tile } from "./generic/Tile";

export function ListEntry({ list, setList, selected, onClose }) {
  return (
    <Tile
      style={{
        backgroundColor: selected ? "#3498ea" : "#c0d8eb",
        border: selected ? "3px solid #c0d8eb" : "0px",
        color: selected ? "white" : undefined,
        alignItems: "center",
        fontSize: "1.5rem",
      }}
      key={list.id}
      onClick={() => {
        setList(list);
        onClose();
      }}
    >
      <span
        style={{
          overflowWrap: "break-word",
          maxWidth: "100%",
          // fontStyle: product.checked ? "italic" : undefined,
        }}
        // onClick={handleUpdate}
      >
        {list.name}{" "}
        {selected ? <span style={{ paddingLeft: "0.25rem" }}>✅</span> : null}
      </span>
    </Tile>
  );
}
